import { render, staticRenderFns } from "./param-consultations.html?vue&type=template&id=3cd283d2&scoped=true&external"
import script from "./param-consultations.js?vue&type=script&lang=js&external"
export * from "./param-consultations.js?vue&type=script&lang=js&external"
import style0 from "./param-consultations.scss?vue&type=style&index=0&id=3cd283d2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd283d2",
  null
  
)

export default component.exports